<template>
  <chat-message-wrapper :message="item" :selectable="selectable" :selected="selected" @select="$emit('select', $event)">
    <div :class="$style.text">{{ item.message }}</div>
  </chat-message-wrapper>
</template>

<script>
import ChatMessageWrapper from "@/components/common/issues/main/chat/ChatMessageWrapper";

export default {
  name:       "ChatItem",
  components: { ChatMessageWrapper },
  props:      ['item', 'selectable', 'selected'],
};
</script>

<style lang="scss" module>
.text {
  word-wrap: break-word;
  white-space: pre-line;
}
</style>
